import { DescriptionOutlinedIcon, Flex, Text } from '@shared/components';

export default function EmptyItemSetQuestionOverlay() {
  return (
    <Flex
      sx={(theme) => ({
        width: 1,
        py: theme.spacing(6),
        borderRadius: theme.shape.rounded(2),
        gap: theme.spacing(2),
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: theme.palette.grey[50],
      })}
    >
      <DescriptionOutlinedIcon sx={{ width: 64, height: 64, color: 'grey.500' }} />
      <Flex
        sx={{
          gap: (theme) => theme.spacing(2),
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Text color='text.secondary' variant='h4'>
          ยังไม่มีคำถามใน Item Set
        </Text>
        <Text color='text.secondary'>กรุณาเพิ่มคำถามเพื่อเริ่มสร้าง Item Set</Text>
      </Flex>
    </Flex>
  );
}
